
export class UploaderDialogInput
{
	url: string;
	data: any;
	allowedContentTypes: Array<string>;

	constructor(url: string, data: any, allowedContentTypes: Array<string>)
	{
		this.url = url;
		this.data = data;
		this.allowedContentTypes = allowedContentTypes;
	}
}

export enum FILE_TYPES
{
	GENERIC = "8A7F03AD-F3FB-4DF4-9E5B-B359AA72F763"
}